import { cn } from 'cn';
import { HTMLAttributes, ReactNode } from 'react';
import { pageContentClassName } from './pageContentClass';

interface PageShellProps {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}

export function PageShell({ title, action, children }: PageShellProps) {
  return (
    <div className={pageContentClassName}>
      <div className="mb-3 flex items-center justify-between gap-3">
        <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
        {action}
      </div>
      {children}
    </div>
  );
}

export function SectionTitle({ children }: { children: ReactNode }) {
  return (
    <p className="mt-5 mb-2 text-sm uppercase tracking-wide text-muted-foreground">
      {children}
    </p>
  );
}

export function HintText({
  children,
  className,
  ...props
}: { children: ReactNode } & HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p className={cn('text-sm text-muted-foreground', className)} {...props}>
      {children}
    </p>
  );
}

export function ErrorText({
  children,
  className,
  ...props
}: { children: ReactNode } & HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p className={cn('mb-3 text-sm text-destructive', className)} {...props}>
      {children}
    </p>
  );
}

export function SuccessText({
  children,
  className,
  ...props
}: { children: ReactNode } & HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p className={cn('mb-3 text-sm text-primary', className)} {...props}>
      {children}
    </p>
  );
}
